import { render } from "./BomHeaderName.vue?vue&type=template&id=dd07f5f6"
import script from "./BomHeaderName.vue?vue&type=script&lang=js"
export * from "./BomHeaderName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__